import {EcSiteApiInterface} from '@/config/axios'

export default {
  // 都道府県一覧取得
  getPrefecture (config = {}) {
    return EcSiteApiInterface.get('/prefecture', config).then(res => {
      return res.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/xhr/xhr-prefecture.js